import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.filter('hide', function (page) {
  return page.name.substr(3)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
